import React from "react";
import "./loader.css";
function CustomLoader() {
  return (
    <div className="loader-bg">
      <div className="loader">
        <div className="circle"></div>
      </div>
    </div>
  );
}

export default CustomLoader;
